import Vue from 'vue/dist/vue.esm.js';

Vue.component('advent-calendar', {
    template: `#advent-calendar`,
    delimiters: ['[[', ']]'],
    props: {
        year: {
            type: Number,
            default: () => new Date().getFullYear()
        },
        month: {
            type: Number,
            default: () => new Date().getMonth() + 1
        },
        currentDate: {
            type: String,
            default: () => new Date().toISOString().split('T')[0]
        },
        newsletterContext: {
            type: String,
            default: 'advent-calendar'
        }
    },
    data() {
        return {
            currentStep: 0, // Start at 0 (hidden) until shown
            email: null,
            agreeToTerms: false,
            agreeToMarketing: false,
            selectedDate: null,
            selectedCalendarEntry: null,
            calendarData: [],
            dismissedCookie: null
        }
    },
    mounted() {
        console.log("Advent Calendar component mounted", {
            year: this.year,
            month: this.month,
            currentDate: this.currentDate
        });
        this.checkDismissedCookie();
        if (this.shouldShowPopup()) {
            this.show();
        }
        this.observeBuyBar();
    },
    computed: {
        todayStr() {
            return this.currentDate || new Date().toISOString().split('T')[0];
        },
        today() {
            const date = new Date(this.todayStr);
            date.setHours(0, 0, 0, 0);
            return date;
        }
    },
    methods: {
        show() {
            const popup = this.$el.querySelector('.advent-calendar-popup');
            if (popup) {
                popup.classList.add('show');
                popup.style.setProperty('display', 'flex', 'important');
            }
            this.currentStep = 1;
        },
        close() {
            this.setCookie('advent_calendar_dismissed', new Date().toISOString(), 1);
            const popup = this.$el.querySelector('.advent-calendar-popup');
            if (popup) {
                popup.classList.remove('show');
                popup.style.display = 'none';
            }
            this.currentStep = 0; // Reset to 0 so badge shows
        },
        shouldShowPopup() {
            if (this.dismissedCookie) {
                const dismissedDate = new Date(this.dismissedCookie);
                const today = new Date();
                if (dismissedDate.toDateString() !== today.toDateString()) {
                    this.deleteCookie('advent_calendar_dismissed');
                    return true;
                }
                return false;
            }
            return true;
        },
        checkDismissedCookie() {
            this.dismissedCookie = this.getCookie('advent_calendar_dismissed');
        },
        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
            return null;
        },
        setCookie(name, value, days = 1) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            const expires = `expires=${date.toUTCString()}`;
            document.cookie = `${name}=${value}; ${expires}; path=/`;
        },
        deleteCookie(name) {
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        },
        showStep(stepNumber) {
            this.currentStep = stepNumber;
            if (stepNumber === 2) {
                if (this.calendarData.length === 0) {
                    this.loadCalendarData();
                } else {
                    this.$nextTick(() => {
                        this.renderCalendar();
                    });
                }
            }
            if (stepNumber === 3 && this.calendarData.length > 0) {
                this.$nextTick(() => {
                    this.renderCalendar();
                });
            }
        },
        loadCalendarData() {
            const url = `/api/v1/advent-calendar/month/${this.year}/${this.month}`;
            const _self = this;

            $.ajax({
                url: url,
                method: 'GET',
                dataType: 'json',
                success: function(data) {
                    _self.calendarData = data || [];
                    _self.$nextTick(() => {
                        _self.renderCalendar();
                    });
                },
                error: function(xhr, status, error) {
                    console.error("Error loading calendar data:", error, xhr);
                    _self.calendarData = [];
                    _self.$nextTick(() => {
                        _self.renderCalendar();
                    });
                }
            });
        },
        renderCalendar() {
            // Calendar is now rendered via Vue template
            this.$forceUpdate();
        },
        getDateStr(day) {
            const dayStr = day < 10 ? '0' + day : day;
            const monthStr = this.month < 10 ? '0' + this.month : this.month;
            return `${this.year}-${monthStr}-${dayStr}`;
        },
        getDayCircleClass(day) {
            if (day > 31) return '';

            const dateStr = this.getDateStr(day);
            const date = new Date(dateStr + 'T00:00:00');
            date.setHours(0, 0, 0, 0);

            const isPast = date < this.today;
            const isToday = dateStr === this.todayStr;
            const isFuture = date > this.today;

            if (isToday) {
                return 'day-burgundy';
            } else if (isPast) {
                return 'day-teal';
            } else if (isFuture) {
                return 'day-gray';
            } else {
                return 'day-gray';
            }
        },
        canSelectDate(day) {
            if (day > 31) return false;

            const dateStr = this.getDateStr(day);
            const date = new Date(dateStr + 'T00:00:00');
            date.setHours(0, 0, 0, 0);

            const isToday = dateStr === this.todayStr;

            // Only allow clicking today's date
            return isToday;
        },
        getStep3DayClass(day) {
            const selectedDay = this.selectedDate ? parseInt(this.selectedDate.split('-')[2]) : null;

            if (day === selectedDay) {
                return 'day-burgundy';
            } else if (day < selectedDay && day <= 4) {
                return 'day-teal';
            } else if (day <= 4 && !selectedDay) {
                return 'day-teal';
            } else if (day <= 31) {
                return 'day-gray';
            }
            return '';
        },
        async submitEmail(event) {
            if (!this.email || !this.isValidEmail(this.email)) {
                return;
            }

            if (!this.agreeToTerms) {
                // Prevent form submission if checkboxes are not checked
                event.preventDefault();
                return false;
            }

            const submitButton = event.target.querySelector('button[type="submit"]');
            const originalButtonText = submitButton ? submitButton.textContent : '';
            if (submitButton) {
                submitButton.disabled = true;
                submitButton.textContent = 'Изпращане...';
            }

            if(this.agreeToMarketing) {
                try {
                    const NewsletterClient = (await import('../clients/NewsletterClient')).default;
                    const newsletterClient = new NewsletterClient();
                    const result = await newsletterClient.SubscribeEmailAsync(this.email, this.newsletterContext);

                    const status = result?.status;

                    if (status === 201 || status === 200) {
                        if (submitButton) {
                            submitButton.disabled = false;
                            submitButton.textContent = originalButtonText;
                        }
                        this.showStep(2);
                    } else {
                        alert('Възникна грешка при записването на имейла. Моля, опитайте отново.');
                        if (submitButton) {
                            submitButton.disabled = false;
                            submitButton.textContent = originalButtonText;
                        }
                    }
                } catch (error) {
                    console.error("Error subscribing email:", error);
                    if (error?.status === 200 || error?.status === 201) {
                        if (submitButton) {
                            submitButton.disabled = false;
                            submitButton.textContent = originalButtonText;
                        }
                        this.showStep(2);
                    } else {
                        alert('Възникна грешка при записването на имейла. Моля, опитайте отново.');
                        if (submitButton) {
                            submitButton.disabled = false;
                            submitButton.textContent = originalButtonText;
                        }
                    }
                }
            }else{
                this.showStep(2);
            }
        },
        async selectDate(dateStr) {
            let entry = this.calendarData.find(e => e.date === dateStr);

            // If no entry found but it's today's date, try to fetch it from API
            if (!entry && dateStr === this.todayStr) {
                try {
                    const url = `/api/v1/advent-calendar/date/${dateStr}`;
                    const _self = this;

                    const response = await new Promise((resolve, reject) => {
                        $.ajax({
                            url: url,
                            method: 'GET',
                            dataType: 'json',
                            success: function(data) {
                                resolve(data);
                            },
                            error: function(xhr, status, error) {
                                // If 404 or no data, that's okay - we'll proceed without entry
                                if (xhr.status === 404) {
                                    resolve(null);
                                } else {
                                    reject(error);
                                }
                            }
                        });
                    });

                    if (response) {
                        entry = response;
                        // Add to calendarData for future reference
                        this.calendarData.push(entry);
                    }
                } catch (error) {
                    console.warn("Error fetching date entry:", error);
                    // Continue anyway - we'll show step 3 even without entry
                }
            }

            // If still no entry, warn but allow proceeding for today's date
            if (!entry && dateStr === this.todayStr) {
                console.warn("No entry found for today's date:", dateStr);
                // Create a minimal entry object for today
                entry = {
                    date: dateStr,
                    promocode: null,
                    text: null,
                    url: null,
                    image: null
                };
            } else if (!entry) {
                console.warn("No entry found for date:", dateStr);
                return;
            }

            this.selectedDate = dateStr;
            this.selectedCalendarEntry = entry;
            this.showStep(3);
        },
        openPresent() {
            if (!this.selectedCalendarEntry) return;
            this.showStep(4);
        },
        shouldShowPromocode() {
            if (!this.selectedCalendarEntry || !this.selectedCalendarEntry.promocode) {
                return false;
            }

            const entryDate = new Date(this.selectedCalendarEntry.date + 'T00:00:00');
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            entryDate.setHours(0, 0, 0, 0);

            const isTodayOrPast = entryDate <= today;
            return isTodayOrPast || this.selectedCalendarEntry.canShowPromocode;
        },
        isValidEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },
        formatDate(dateStr) {
            if (!dateStr) return '';
            const date = new Date(dateStr + 'T00:00:00');
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
            return `${day} / ${month} / ${year}`;
        },
        observeBuyBar() {
            // Watch for buy-bar.show class and adjust advent calendar badge position
            const badge = this.$el.querySelector('.advent-calendar-badge');
            if (!badge) return;

            const buyBar = document.querySelector('.buy-bar');
            if (!buyBar) return;

            const observer = new MutationObserver(() => {
                if (buyBar.classList.contains('show')) {
                    badge.style.bottom = '125px';
                } else {
                    badge.style.bottom = '';
                }
            });

            observer.observe(buyBar, {
                attributes: true,
                attributeFilter: ['class']
            });

            // Check initial state
            if (buyBar.classList.contains('show')) {
                badge.style.bottom = '125px';
            }

            // Cleanup on component destroy
            this.$once('hook:beforeDestroy', () => {
                observer.disconnect();
            });
        }
    }
});

